'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { useSession } from 'next-auth/react';
import { trackUserSession } from '@/utils/trackUserSession';

export function useTrackPageVisit(enabled = true) {
  const pathname = usePathname();
  const { data: session } = useSession();
  const accessToken = (session?.user as { accessToken?: string } | undefined)?.accessToken;

  useEffect(() => {
    if (!enabled || !pathname || !accessToken) return;
    trackUserSession({ accessToken, page: pathname });
  }, [enabled, pathname, accessToken]);
}
